// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"88702f84","84":"3a46c673","125":"d0a7a495","154":"344bb4c3","287":"3a299914","424":"eb46e713","511":"57558cde","784":"eb7ae6d8","814":"6ce2b822","829":"b6b50b4b","836":"dae808a3","930":"b0bb6409"}[chunkId] + ".chunk.js";
};